import { Injectable } from '@angular/core';
import { ConfigurationModule } from '../../configuration.module';
import { AuthorizationCodeRequestConfiguration } from './authorization-code-request-configuration';

@Injectable({
  providedIn: ConfigurationModule
})
export class AuthorizationCodeRequestConfigurationService {
  configuration: AuthorizationCodeRequestConfiguration;

  constructor() { }

  loadConfiguration(configuration) {
    this.configuration = {
      path:"/connect/token",
      contentType:"application/x-www-form-urlencoded",
     redirect_uri:configuration.redirect_uri,
     addBasicAuthHeader:false
  }
}
}